import React from "react";
import {Navigate, Route, Routes} from "react-router-dom";
import {
  Reset as ResetPage,
  Registration as RegistrationPage,
  Authorization as AuthorizationPage,
  PasswordReset as PasswordResetPage,
} from "../pages";

const AuthRoutes = () => {
  return (
    <Routes>
      <Route path='/' element={<AuthorizationPage/>}/>
      <Route path='/reset' element={<ResetPage/>}/>
      <Route path='/registration' element={<RegistrationPage/>}/>
      <Route path='/password-reset' element={<PasswordResetPage/>}/>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  )
}

export default AuthRoutes
